/* eslint-disable no-console */
const NAMESPACE = '@inter-ikea-guida';
const storage = window.localStorage;
export const setItem = (key, value) => {
    try {
        const saveValue = isPrimitive(value) ? value : JSON.stringify(value);
        storage.setItem(`${NAMESPACE}/${key}`, saveValue);
    }
    catch (error) {
        console.log(error);
    }
};
export const getItem = (key) => {
    const item = storage.getItem(`${NAMESPACE}/${key}`);
    try {
        return JSON.parse(item);
    }
    catch {
        return item;
    }
};
export const removeItem = (key) => {
    storage.removeItem(`${NAMESPACE}/${key}`);
};
const isPrimitive = (value) => typeof value !== 'object';
//# sourceMappingURL=storage.js.map